import { Component } from "react";
import { Phone } from "lucide-react";
import { LOCATIONS } from "../lib/content";

const WB = LOCATIONS["west-branch"];

/** A data surprise must degrade to something a renter can act on, never a white screen. */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Route error boundary caught:", error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div data-testid="route-error-boundary" className="mx-auto max-w-2xl px-5 py-32 text-center lg:px-10">
        <h1 className="font-display text-3xl font-extrabold text-navy">
          Something went wrong on this page
        </h1>
        <p className="mx-auto mt-4 max-w-md text-sm text-slate-600">
          Your reservation has not been charged. Please reload, or call us and we'll book you over
          the phone in a minute.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <button
            type="button"
            data-testid="error-boundary-reload"
            onClick={() => window.location.reload()}
            className="rounded-full bg-ember px-7 py-3.5 font-bold text-white hover:bg-ember-hover"
          >
            Reload the page
          </button>
          <a
            href={WB.phoneHref}
            data-testid="error-boundary-call"
            className="inline-flex items-center gap-2 rounded-full border border-navy/20 px-7 py-3.5 font-bold text-navy hover:bg-sand-card"
          >
            <Phone className="h-4 w-4" aria-hidden="true" />
            Call {WB.phone}
          </a>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
